var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 62,
    viewBox: "0 0 50 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C11.2158 0 0.000254512 11.1259 0.000254512 24.7845C-0.0903696 44.764 24.05 61.3304 25 62C25 62 50.0904 44.764 49.9998 24.8C49.9998 11.1259 38.7842 0 25 0ZM25 37.2C18.0938 37.2 12.5001 31.651 12.5001 24.8C12.5001 17.949 18.0938 12.4 25 12.4C31.9062 12.4 37.4999 17.949 37.4999 24.8C37.4999 31.651 31.9062 37.2 25 37.2Z",
    fill: "#5DF99C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.bc7adbab55a57c7158b3a98226e1648b.svg";
export { ForwardRef as ReactComponent };